var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBiddings = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 74.5 33.9",
    style: {
      enableBackground: "new 0 0 74.5 33.9"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "one"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3,32.1h5.1V2h-3.6c-1.2,3-3.3,4.2-6.5,4v3.2h5.1v22.9H11.3z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "two"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2,10.8V8.3c0-3.4-2.8-6.2-6.2-6.2H8.9c-3.4,0-6.2,2.8-6.2,6.2v4.1h5.2v-3C7.9,7.5,9.4,6,11.3,6l0,0 c1.9,0,3.4,1.5,3.4,3.4c0,0,0-1.9,0,1.4c0,4.9-12.1,11.1-12.1,17.1v4.4h17.6v-4.4H8.1C8.1,22,20.2,18.1,20.2,10.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "three"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,18.3c1.9,0,3.4,1.5,3.4,3.4v2.9c0,1.9-1.5,3.4-3.4,3.4l0,0c-1.9,0-3.4-1.5-3.4-3.4v-2H2.6v3.1c0,3.4,2.8,6.2,6.2,6.2 h5.1c3.4,0,6.2-2.8,6.2-6.2v-4c0-2.4-1.3-4.4-3.3-5.5c2-1,3.3-3.1,3.3-5.5V8.2c0-3.4-2.8-6.2-6.2-6.2H8.8C5.4,2,2.6,4.8,2.6,8.2 v2.5h5.2V9.3c0-1.9,1.5-3.4,3.4-3.4l0,0c1.9,0,3.4,1.5,3.4,3.4v1.8c0,1.9-1.5,3.4-3.4,3.4H8.3v3.7L11.2,18.3L11.2,18.3z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "four"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6,22.7V2.3h-5.9L1.5,22.7v4.2h11.3v5.4h5.9v-5.4h2.5v-4.2H18.6z M12.7,22.7H6.5l6.2-12.1V22.7z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "five"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8,19.4H2.6L3.5,2.2h15.7V6H8.9l-0.5,7.7c1.4-1.8,3.1-2.2,4.3-2.3h1.8c3.9,0,5.6,3.4,5.6,7.4v6.9c0,3.4-2.8,6.2-6.2,6.2 H8.8c-3.4,0-6.2-2.8-6.2-6.2v-3h5.2v1.9c0,1.9,1.5,3.4,3.4,3.4l0,0c1.9,0,3.4-1.5,3.4-3.4v-5.9c0-1.9-1.5-3.4-3.4-3.4l0,0 c-1.9,0-3.4,1.5-3.4,3.4C7.8,18.7,7.8,19.4,7.8,19.4z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "six"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8,24.6c0,1.9,1.5,3.4,3.4,3.4l0,0c1.9,0,3.4-1.5,3.4-3.4v-4.9c0-1.9-1.5-3.4-3.4-3.4l0,0c-1.9,0-3.4,1.5-3.4,3.4 C7.8,19.7,7.8,24.6,7.8,24.6z M2.6,8.3c0-3.4,2.8-6.2,6.2-6.2h5.1c3.4,0,6.2,2.8,6.2,6.2v1.5h-5.4V9.4c0-1.9-1.5-3.4-3.4-3.4l0,0 C9.4,6,7.9,7.5,7.9,9.4v6l0.5-0.7c1.4-1.8,3.1-2.2,4.3-2.3h1.8c3.9,0,5.6,3.4,5.6,7.4v5.9c0,3.4-2.8,6.2-6.2,6.2H8.8 c-3.4,0-6.2-2.8-6.2-6.2v-3C2.6,22.7,2.6,8.3,2.6,8.3z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "seven"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "3,2.1 19.8,2.1 19.8,6.5 11.7,32.2 5.9,32.2 14.6,5.8 3,5.9  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "spades"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8,19.1c-0.1-6.8-9.3-6.8-12.7-17.1c-3.4,10.3-12.6,10.3-12.7,17.1c0.1,3.5,2.7,6.2,6.2,6.2c2.6,0,4.9-1.7,5.8-4 c0.2,0.8,0.3,1.6,0.3,2.4c0,4.3-3.4,7.8-7.8,7.8v0.7h16.4v-0.7c-4.3,0-7.8-3.4-7.8-7.8c0-0.8,0.1-1.6,0.3-2.4c0.9,2.4,3.1,4,5.8,4 C49.1,25.2,51.8,22.5,51.8,19.1z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "hearts"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1,32.1c3.3-12.3,12.5-15.7,12.3-24c0-3.9-2.8-6.1-6.1-6.1c-3.3,0-6.1,2.8-6.1,6.1C39.1,4.8,36.3,2,33,2 s-6.1,2.2-6.1,6.1C26.6,16.4,35.8,19.8,39.1,32.1z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "diamonds"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "39.1,2 28.4,17 39.1,32.1 49.9,17  "
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "clubs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8,25.1c3.5,0,6.4-2.8,6.4-6.4s-2.8-6.4-6.4-6.4c-0.8,0-1.5,0.1-2.2,0.5l0,0l0,0c1.2-1.2,1.9-2.7,1.9-4.5 c0-3.5-2.8-6.4-6.4-6.4c-3.5,0-6.4,2.8-6.4,6.4c0,1.8,0.7,3.3,1.9,4.5l0,0l0,0c-0.7-0.2-1.4-0.5-2.2-0.5c-3.5,0-6.4,2.8-6.4,6.4 s2.8,6.4,6.4,6.4c2.7,0,5.1-1.8,6-4.1c0.2,0.8,0.4,1.7,0.4,2.5c0,4.5-3.5,8-8,8v0.7h16.9v-0.7c-4.5,0-8-3.5-8-8 c0-0.8,0.1-1.7,0.4-2.5C40.8,23.3,43.1,25.1,45.8,25.1z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "noTrump"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "72.1,2 72.1,7.3 64.4,7.3 64.4,32.1 59.1,32.1 59.1,7.3 51.3,7.3 51.3,2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.4,2 43.4,21.8 33.2,2 27.9,2 27.9,32.1 33.2,32.1 33.2,12.3 43.4,32.1 48.7,32.1 48.7,2  "
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBiddings, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/biddings.d005756e.svg";
export { ForwardRef as ReactComponent };